import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import App from './App';
import Site from './site/Site';
import './index.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <BrowserRouter>
            <Routes>
                {/* Previous iteration of the site, preserved under /old */}
                <Route path="/old/*" element={<App />} />
                {/* Revamped site */}
                <Route path="/*" element={<Site />} />
            </Routes>
        </BrowserRouter>
    </React.StrictMode>
);
